import React from "react";
import PropTypes from "prop-types";

const Hero = props => (
  <div className={`hero ${props.className ? props.className : ""}`}>
    <div className="hero__content">
      <div className="container">{props.children}</div>
    </div>
  </div>
);

Hero.propTypes = {
  className: PropTypes.string
};

Hero.defaultProps = {
  className: undefined
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/layout/Hero.js